import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {environment} from "../../../environments/environment";
import {
  SearchRepairCentreDto
} from "../../auto-generated-server-dtos/adjuster/configuration/search-repair-centre-dto";

@Injectable({
  providedIn: 'root'
})
export class SearchRepairCentreService {

  constructor(private httpClient: HttpClient) { }

  searchRepairCentre(search: string) {
    return this.httpClient.get<SearchRepairCentreDto[]>(`${environment.apiServer}/Adjuster/Configuration/SearchRepairCentre?`, {params: {search}});
  }
}
